import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./add-remainder.css";
import { Card, Button, ProgressBar, Form, Container, Row, Col } from "react-bootstrap";
import moment from "moment";
import loop from "../../assets/svg/loop.svg";
import SearchWithAPI from "../searchbox/searchbox.js";
import SearchWithFreeTextAPI from "../searchbox/searchbox-free-text.js";
import chipClose from "../../assets/svg/close-chip.svg";
import { validateRemainderApi } from "./asset-api.js";
import edit from "../../assets/svg/edit.svg";

const AddRemainderModal = ({ editReminder, invoiceDate, warrantyUnit, warrantyPeriod, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const navigate = useNavigate();
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "600px",

      overflowY: "auto",
    },
  };

  const [selectedStatus, setSelectedStatus] = useState("Static");
  const [showSender, setShowSender] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [remainderDate, setRemainderDate] = useState("");
  const [remainderTime, setRemainderTime] = useState("");
  const [title, setTitle] = useState("");
  const [issueTypeList, setIssueTypeList] = useState([
    { value: "static", label: "Static" },
    { value: "recurring", label: "Recurring" },
    { value: "warranty", label: "Warranty" },
  ]);
  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };
  const [invoiceFormattedDate, setInvoiceFormattedDate] = useState("");
  const [warrantyDate, setWarrantyDate] = useState("");
  const [remindBefore, setRemindBefore] = useState("");
  const [remindBeforeType, setRemindBeforeType] = useState("Week");
  const [templateOption, setTemplateOption] = useState(null);
  const [userOption, setUserOption] = useState(null);
  const [inviteUsers, setInviteUser] = useState([]);
  const [userErrorMsg, setUserErrorMsg] = useState("");

  const [mobileSearch, setMobileSearch] = useState("");
  const [mobileErrorMsg, setMobileErrorMsg] = useState("");
  const [inviteMobiles, setInviteMobile] = useState([]);

  const handleMobileDropdownChange = (option) => {
    setMobileSearch(option.value);
  };
  const handleMobileOnChange = (term) => {
    setMobileSearch(term);
  };

  const [emailSearch, setEmailSearch] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [inviteEmails, setInviteEmail] = useState([]);

  const handleEmailDropdownChange = (option) => {
    setEmailSearch(option.value);
  };
  const handleEmailOnChange = (term) => {
    setEmailSearch(term);
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [slotAvailable, setSlotAvailable] = useState(false);
  const [repeatPayload, setRepeatPayload] = useState(false);
  const [selectedRepeatType, setRepeatType] = useState("daily");
  const [everyDayOnce, setEveryDayOnce] = useState(1); // Common for all daily, weekly, monthly
  const [selectedDaysOption, setSelectedDaysOption] = useState("");
  const [selectedMonthOption, setSelectedMonthOption] = useState(""); // onDay, position
  const [repeatMonth, setRepeatMonth] = useState(1);
  const [dayOfMonth, setDayOfMonth] = useState(1);
  const [selectedMonthlyPositionOption, setSelectedMonthlyPositionOption] = useState(""); // First, Second, Third, Fourth, Last
  const [selectedPositionDayOption, setSelectedPositionDayOption] = useState(""); // Sun, Mon, Tue, Wed, ...

  const [selectedDays, setSelectedDays] = useState([]);

  const days = ["S", "M", "T", "W", "T", "F", "S"];
  const [daily, setDaily] = useState("");

  const toggleDaySelection = (index) => {
    setSelectedDays((prevSelected) => (prevSelected.includes(index) ? prevSelected.filter((day) => day !== index) : [...prevSelected, index]));
  };
  useEffect(() => {
    if (editReminder != null) {
      setSelectedStatus(editReminder.type);
      if (editReminder.template_group_id != null && editReminder.template_group_id !== "") {
        setTemplateOption({ value: editReminder.template_group_id, label: editReminder.template_group });
      }
      setInviteUser(editReminder.user_labels ?? []);
      setInviteEmail(editReminder.emails ?? []);
      setInviteMobile(editReminder.mobile_numbers ?? []);
      if (editReminder.type === "Static") {
        setRemainderDate(editReminder.date);
        setRemainderTime(editReminder.time);
      }
      if (editReminder.type === "Recurring") {
        setEveryDayOnce(editReminder.repeat.repeat);
        setRemainderTime(editReminder.repeat.time);
        if (editReminder.repeat.recurrence_type === "daily") {
          setRepeatType(editReminder.repeat.recurrence_type);
          setSelectedDaysOption(editReminder.repeat.repeat_on.week_days_only === true ? "weekDays" : "everyDays");
        }
        if (editReminder.repeat.recurrence_type === "weekly") {
          setRepeatType(editReminder.repeat.recurrence_type);
          const tempSelectedDays = [...selectedDays];
          editReminder.repeat.repeat_on.days_of_week?.map((day) => {
            if (day === "sunday") {
              tempSelectedDays.push(0);
            }
            if (day === "monday") {
              tempSelectedDays.push(1);
            }
            if (day === "tuesday") {
              tempSelectedDays.push(2);
            }
            if (day === "wednesday") {
              tempSelectedDays.push(3);
            }
            if (day === "thursday") {
              tempSelectedDays.push(4);
            }
            if (day === "friday") {
              tempSelectedDays.push(5);
            }
            if (day === "saturday") {
              tempSelectedDays.push(6);
            }
          });
          setSelectedDays(tempSelectedDays);
        }
        if (editReminder.repeat.recurrence_type === "monthly_fixed") {
          setRepeatType("monthly");
          setSelectedMonthOption("onDay");
          setDayOfMonth(editReminder.repeat.repeat_on.day_of_month);
        }

        if (editReminder.repeat.recurrence_type === "monthly_relative") {
          setRepeatType("monthly");
          setSelectedMonthOption("position");
          setDayOfMonth(editReminder.repeat.repeat_on.day_of_month);
          setTimeout(() => {
            document.getElementById("position").value = editReminder.repeat.repeat_on.position;
            document.getElementById("position_day").value = editReminder.repeat.repeat_on.day;
          }, 1000);
        }
        setTimeout(() => {
          document.getElementById("start_date").value = editReminder.repeat.start_date;
          document.getElementById("end_date").value = editReminder.repeat.end_date;
        }, 1000);
      }
      if (editReminder.type === "Warranty") {
        setRemindBefore(editReminder.warranty.value);
        setRemindBeforeType(editReminder.warranty.unit);
        setRemainderTime(editReminder.warranty.time);
      }
    }
    if (invoiceDate != null) {
      setInvoiceFormattedDate(moment(invoiceDate).format("DD MMMM YYYY"));
      const myDate = moment(invoiceDate);
      if (warrantyUnit === "Week" && warrantyPeriod !== "") {
        setWarrantyDate(myDate.clone().add(warrantyPeriod, "weeks").format("YYYY-MM-DD"));
      }
      if (warrantyUnit === "Month" && warrantyPeriod !== "") {
        setWarrantyDate(myDate.clone().add(warrantyPeriod, "months").format("YYYY-MM-DD"));
      }
      if (warrantyUnit === "Year" && warrantyPeriod !== "") {
        setWarrantyDate(myDate.clone().add(warrantyPeriod, "years").format("YYYY-MM-DD"));
      }
    }
  }, [editReminder, invoiceDate]);

  useEffect(() => {
    if (selectedStatus === "Recurring") {
      repeatPayloadObject();
    }
    repeatSentence();
  }, [remainderDate, remindBefore, remindBeforeType, remainderTime, selectedRepeatType, everyDayOnce, selectedDays, selectedDaysOption, selectedMonthOption, repeatMonth, dayOfMonth, daily]);

  const repeatPayloadObject = () => {
    var payload = {
      start_date: document.getElementById("start_date").value,
      end_date: document.getElementById("end_date").value,
      repeat: everyDayOnce,
      time: remainderTime !== "" ? moment(remainderTime, "HH:mm").format("hh:mm:ss") : "00:00:00",
    };
    if (selectedRepeatType === "daily") {
      var dailyPayload = {
        week_days_only: selectedDaysOption === "weekDays" ? true : false,
        days_of_week: [],
      };
      payload["recurrence_type"] = selectedRepeatType;
      payload["repeat_on"] = dailyPayload;
    }

    if (selectedRepeatType === "weekly") {
      const fullDays = selectedDays.map((day) => {
        if (day === 0) {
          return "sunday";
        }
        if (day === 1) {
          return "monday";
        }
        if (day === 2) {
          return "tuesday";
        }
        if (day === 3) {
          return "wednesday";
        }
        if (day === 4) {
          return "thursday";
        }
        if (day === 5) {
          return "friday";
        }
        if (day === 6) {
          return "saturday";
        }
        return "";
      });
      var weeklyPayload = {
        week_days_only: false,
        days_of_week: fullDays,
      };
      payload["recurrence_type"] = selectedRepeatType;
      payload["repeat_on"] = weeklyPayload;
    }

    if (selectedRepeatType === "monthly") {
      if (selectedMonthOption === "onDay") {
        var monthlyPayload = {
          day_of_month: dayOfMonth,
          day: "",
          position: "",
          week_days_only: false,
          days_of_week: [],
        };
        payload["recurrence_type"] = "monthly_fixed";
        payload["repeat_on"] = monthlyPayload;
      }
      if (selectedMonthOption === "position") {
        var monthlyPayload = {
          day_of_month: dayOfMonth,
          position: document.getElementById("position").value,
          day: document.getElementById("position_day").value,
          week_days_only: false,
          days_of_week: [],
        };
        payload["recurrence_type"] = "monthly_relative";
        payload["repeat_on"] = monthlyPayload;
      }
    }
    const finalPayload = {
      date: "",
      from: remainderTime,
      repeat_booking: true,
      repeat: payload,
    };
    setRepeatPayload(finalPayload);
  };

  const validateRemainder = async () => {
    var payload = {
      trigger_seq: repeatSentence(),
      type: selectedStatus,
    };
    if (selectedStatus === "Static") {
      payload["date"] = remainderDate;
      payload["time"] = remainderTime !== "" ? moment(remainderTime, "HH:mm").format("hh:mm:ss") : "00:00:00";
    }
    if (selectedStatus === "Recurring") {
      payload["repeat"] = repeatPayload.repeat;
      payload["time"] = remainderTime !== "" ? moment(remainderTime, "HH:mm").format("hh:mm:ss") : "00:00:00";
    }
    if (selectedStatus === "Warranty") {
      payload["warranty"] = { value: remindBefore, unit: remindBeforeType, time: remainderTime !== "" ? moment(remainderTime, "HH:mm").format("hh:mm:ss") : "00:00:00" };
    }

    const response = await validateRemainderApi(payload);
    if (response.status === 200) {
      if (response.data.success === true) {
        setShowSender(true);
      }
    }
  };

  const saveRemainder = async () => {
    var payload = {
      trigger_seq: repeatSentence(),
      type: selectedStatus,
      template_group_id: templateOption != null && templateOption !== "" ? templateOption.value : "",
      template_group: templateOption != null && templateOption !== "" ? templateOption.label : "",
      users: inviteUsers.filter((item) => item.value !== "").map((item) => item.value),
      user_labels: inviteUsers.filter((item) => item.value !== ""),
      emails: inviteEmails,
      mobile_numbers: inviteMobiles,
    };
    if (selectedStatus === "Static") {
      payload["date"] = remainderDate;
      payload["time"] = remainderTime !== "" ? moment(remainderTime, "HH:mm").format("hh:mm:ss") : "00:00:00";
    }
    if (selectedStatus === "Recurring") {
      payload["repeat"] = repeatPayload.repeat;
    }
    if (selectedStatus === "Warranty") {
      payload["warranty"] = { value: remindBefore, unit: remindBeforeType, time: remainderTime !== "" ? moment(remainderTime, "HH:mm").format("hh:mm:ss") : "00:00:00" };
    }
    console.log(payload);
    if (editReminder != null) {
      payload["id"] = editReminder.id;
    }
    onSuccess(payload);
  };
  function commonFormatDate(inputDate, formatString) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
              const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());
      
              // Format the date
              return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
        return moment(inputDate).format(formatString);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
  const convertTo12HourFormat = (time) => {
    if (time != null) {
      let [hours, minutes] = time.split(":");
      let period = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      return `${hours}:${minutes} ${period}`;
    } else {
      return "";
    }
  };
  const repeatSentence = () => {
    if (selectedStatus === "Static" && remainderDate !== "" && remainderTime !== "") {
      return "Remainder is set for " + commonFormatDate(remainderDate, "MMMM D, YYYY") + ", at " + convertTo12HourFormat(remainderTime) + ".";
    }
    if (selectedStatus === "Warranty" && warrantyDate !== "" && remainderTime !== "") {
      const myDate = moment(warrantyDate);
      let reminderBeforeDate;
      if (remindBeforeType === "Week" && remindBefore !== "") {
        reminderBeforeDate = myDate.clone().subtract(remindBefore, "weeks").format("MMMM D, YYYY");
      }
      if (remindBeforeType === "Month" && remindBefore !== "") {
        reminderBeforeDate = myDate.clone().subtract(remindBefore, "months").format("MMMM D, YYYY");
      }
      if (remindBeforeType === "Year" && remindBefore !== "") {
        reminderBeforeDate = myDate.clone().subtract(remindBefore, "years").format("MMMM D, YYYY");
      }
      return "Remainder is set for before warranty " + reminderBeforeDate + ", at " + convertTo12HourFormat(remainderTime) + ".";
    }
    if (repeatPayload.repeat?.recurrence_type === "daily") {
      if (repeatPayload.repeat.repeat_on.week_days_only === true) {
        return "The remainder will repeat week days from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", at " + convertTo12HourFormat(repeatPayload.from) + ".";
      }
      return "The remainder will repeat every " + repeatPayload.repeat.repeat + " day(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", at " + convertTo12HourFormat(repeatPayload.from) + ".";
    } else if (repeatPayload.repeat?.recurrence_type === "weekly") {
      return "The remainder will repeat every " + repeatPayload.repeat.repeat + " week(s) once from " + repeatPayload.repeat.repeat_on.days_of_week.join(",") + " from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", at " + convertTo12HourFormat(repeatPayload.from) + "";
    } else if (repeatPayload.repeat?.recurrence_type === "monthly_fixed") {
      return "The remainder will repeat on the " + repeatPayload.repeat.repeat_on.day_of_month + " of every " + repeatPayload.repeat.repeat + " month(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", at " + convertTo12HourFormat(repeatPayload.from) + "";
    } else if (repeatPayload.repeat?.recurrence_type === "monthly_relative") {
      return "The remainder will repeat on the " + repeatPayload.repeat.repeat_on.position + " " + repeatPayload.repeat.repeat_on.day + " of every " + repeatPayload.repeat.repeat + " month(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", at " + convertTo12HourFormat(repeatPayload.from) + "";
    } else {
      return "";
    }
  };

  const handleTemplateDropdownChange = (option) => {
    setTemplateOption(option);
  };

  const handleUserDropdownChange = (option) => {
    setUserOption(option);

    const index = inviteUsers.findIndex((element) => element.value === option.value);
    if (index === -1) {
      setInviteUser([...inviteUsers, option]);
      setUserOption(null);
    } else {
      setUserErrorMsg("Already exists");
    }
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div>
            <div className="px-2 modal-header style-justify-start">
              <div className="modal-title">Add remainder</div>
            </div>
            <div className="px-3 py-3">
              {showSender === false && (
                <div>
                  <div className="style-justify-start" style={{ flexWrap: "wrap", gap: "8px" }}>
                    {issueTypeList.map((type, index) => (
                      <label key={`type${index}`} className={`${selectedStatus === type.label ? "radio-btn-txt-active" : "radio-btn-txt-inactive"}`}>
                        <input type="radio" name="options" value={type.label} checked={selectedStatus === type.label} onChange={handleChange} className="custom-radio" />
                        <span className={`px-2 ${selectedStatus === type.label ? "radio-btn-txt-active" : "radio-btn-txt-inactive"}`}>{type.label}</span>
                      </label>
                    ))}
                  </div>
                  {/*  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.type}</span> */}
                  {selectedStatus === "Static" && (
                    <Row className="mt-2" style={{ width: "100%" }}>
                      <Col sm={6}>
                        <div>
                          <div className="field-title mb-1">Date</div>
                          <input
                            type="date"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={remainderDate}
                            onChange={(event) => {
                              setRemainderDate(event.target.value);
                            }}
                          />
                        </div>
                      </Col>
                      <Col sm={6} className="px-0">
                        <div>
                          <div className="field-title mb-1">Time</div>
                          <input
                            type="time"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={remainderTime}
                            onChange={(event) => {
                              setRemainderTime(event.target.value);
                            }}
                          />
                        </div>
                      </Col>

                      {/*  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.in_time}</span> */}
                    </Row>
                  )}

                  {selectedStatus === "Recurring" && (
                    <div>
                      <div className="mt-3" style={{ width: "100%" }}>
                        <select value={selectedRepeatType} className="input-field w-100 px-2 py-2" onChange={(e) => setRepeatType(e.target.value)}>
                          <option value="daily">Repeat daily</option>
                          <option value="weekly">Repeat weekly</option>
                          <option value="monthly">Repeat monthly</option>
                        </select>

                        {selectedRepeatType === "daily" && (
                          <div className="d-flex flex-column mb-2 mt-2" style={{ gap: "6px" }}>
                            <div className="style-justify-start" style={{ gap: "12px" }}>
                              <div className="style-justify-center" style={{ gap: "12px" }}>
                                <input
                                  type="radio"
                                  name="dailyDayOption"
                                  value="everyDays"
                                  checked={selectedDaysOption === "everyDays"}
                                  onChange={(event) => {
                                    console.log("dailyDayOption day", event.target.value);
                                    setSelectedDaysOption(event.target.value);
                                  }}
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>Every</label>
                              </div>

                              <div>
                                <input
                                  type="number"
                                  value={everyDayOnce}
                                  onChange={(event) => {
                                    setEveryDayOnce(event.target.value);
                                  }}
                                  name="di"
                                  min={1}
                                  style={{ borderRadius: "12px", gap: "8px", backgroundColor: "#F5F5F5", width: "40px", height: "34px", border: "none", textAlign: "center", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                                />
                              </div>

                              <div style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>day(s) once</div>
                            </div>

                            <div className="d-flex align-items-center mt-2 mb-4" style={{ gap: "12px" }}>
                              <input
                                type="radio"
                                name="dailyDayOption"
                                value="weekDays"
                                checked={selectedDaysOption === "weekDays"}
                                onChange={(event) => {
                                  console.log("dailyDayOption week", event.target.value);
                                  setSelectedDaysOption(event.target.value);
                                }}
                                style={{ width: "18px", height: "18px" }}
                              />
                              <label style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>Week days only</label>
                            </div>
                          </div>
                        )}
                        {selectedRepeatType === "weekly" && (
                          <div className="d-flex flex-column mb-2 mt-4" style={{ gap: "6px" }}>
                            <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                              <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                                <label style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>Every</label>
                              </div>

                              <div>
                                <input
                                  type="number"
                                  value={everyDayOnce}
                                  onChange={(event) => {
                                    setEveryDayOnce(event.target.value);
                                  }}
                                  style={{ borderRadius: "12px", gap: "8px", backgroundColor: "#F5F5F5", width: "34px", height: "34px", border: "none", textAlign: "center", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                                />
                              </div>

                              <div style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>week(s) once</div>
                            </div>

                            <div className="d-flex align-items-center mt-2 mb-4" style={{ gap: "8px" }}>
                              {days.map((day, index) => (
                                <div
                                  key={index}
                                  onClick={() => toggleDaySelection(index)}
                                  style={{
                                    borderRadius: "100px",
                                    width: "40px",
                                    height: "40px",
                                    backgroundColor: selectedDays.includes(index) ? "#3B84E6" : "#FFFFFF",
                                    color: selectedDays.includes(index) ? "#FFFFFF" : "#1E1E1E",
                                    border: "1px solid #E5E5E5",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                  }}
                                  className="px-3 py-3 d-flex justify-content-center align-items-center"
                                >
                                  {day}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {selectedRepeatType === "monthly" && (
                          <div className="d-flex flex-column mb-2 mt-1" style={{ gap: "6px" }}>
                            <div className="d-flex align-items-center mb-2" style={{ gap: "12px" }}>
                              <div className="d-flex align-items-center mb-2" style={{ gap: "12px" }}>
                                <label style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>Every</label>
                              </div>

                              <div>
                                <input
                                  type="number"
                                  value={everyDayOnce}
                                  onChange={(event) => {
                                    setEveryDayOnce(event.target.value);
                                  }}
                                  defaultValue="1"
                                  name="mi1"
                                  style={{ borderRadius: "12px", gap: "8px", backgroundColor: "#F5F5F5", width: "34px", height: "34px", border: "none", textAlign: "center", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                                />
                              </div>

                              <div style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>month(s) once</div>
                            </div>

                            <div className="d-flex align-items-center mb-2" style={{ gap: "12px" }}>
                              <div className="d-flex align-items-center mb-2" style={{ gap: "12px" }}>
                                <input
                                  type="radio"
                                  name="mon"
                                  value="onDay"
                                  checked={selectedMonthOption === "onDay"}
                                  onChange={(event) => {
                                    setSelectedMonthOption(event.target.value);
                                  }}
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>On day</label>
                              </div>

                              <div className="mb-2">
                                <input
                                  type="number"
                                  value={dayOfMonth}
                                  onChange={(event) => {
                                    setDayOfMonth(event.target.value);
                                  }}
                                  name="mi2"
                                  style={{ borderRadius: "12px", gap: "8px", backgroundColor: "#F5F5F5", width: "40px", height: "34px", border: "none", textAlign: "center", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                                />
                              </div>

                              <div style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }} className="mb-2">
                                day(s) once
                              </div>
                            </div>

                            <div className="d-flex align-items-center mb-2" style={{ gap: "12px" }}>
                              <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                                <input
                                  type="radio"
                                  name="mon"
                                  value="position"
                                  checked={selectedMonthOption === "position"}
                                  onChange={(event) => {
                                    setSelectedMonthOption(event.target.value);
                                  }}
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label style={{ fontWeight: "500", fontSize: "14.5px", color: "#1E1E1E" }}>On the</label>
                              </div>

                              <div>
                                <select
                                  id="position"
                                  onChange={() => {
                                    repeatPayloadObject();
                                  }}
                                  style={{ borderRadius: "12px", gap: "8px", backgroundColor: "#F5F5F5", border: "none" }}
                                  className="px-2 py-2"
                                >
                                  <option value="">Select</option>
                                  <option value="first">First</option>
                                  <option value="second">Second</option>
                                  <option value="third">Third</option>
                                  <option value="fourth">Fourth</option>
                                  <option value="last">Last</option>
                                </select>
                              </div>

                              <div>
                                <select
                                  id="position_day"
                                  onChange={() => {
                                    repeatPayloadObject();
                                  }}
                                  style={{ borderRadius: "12px", gap: "8px", backgroundColor: "#F5F5F5", border: "none" }}
                                  className="px-2 py-2"
                                >
                                  <option>Select</option>
                                  <option value="sunday">Sunday</option>
                                  <option value="monday">Monday</option>
                                  <option value="tuesday">Tuesday</option>
                                  <option value="wednesday">Wednesday</option>
                                  <option value="thursday">Thursday</option>
                                  <option value="friday">Friday</option>
                                  <option value="saturday">Saturday</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="d-flex flex-column mb-3" style={{ gap: "16px" }}>
                        <div style={{ fontWeight: "600", fontSize: "14px", color: "#1E1E1E" }}>Start Date & End Date</div>
                        <div className="d-flex justify-content-start">
                          <div className="col-5">
                            <input
                              type="date"
                              id="start_date"
                              onChange={() => {
                                repeatPayloadObject();
                              }}
                              style={{ width: "100%", border: "1px solid #E5E5E5", borderRadius: "10px", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                              className="px-2 py-2"
                              defaultValue={new Date().toISOString().split("T")[0]}
                            />
                          </div>

                          <div className="col-5 ms-2">
                            <input
                              type="date"
                              id="end_date"
                              onChange={() => {
                                repeatPayloadObject();
                              }}
                              style={{ width: "100%", border: "1px solid #E5E5E5", borderRadius: "10px", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                              className="px-2 py-2"
                              defaultValue={new Date(Date.now() + 86400000).toISOString().split("T")[0]}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column mb-2" style={{ gap: "16px" }}>
                        <div className="style-justify-start">
                          <div style={{ fontWeight: "600", fontSize: "14px", color: "#1E1E1E" }}>Time :</div>
                          <div className="ms-2 col-4">
                            <input
                              type="time"
                              value={remainderTime}
                              onChange={(event) => {
                                setRemainderTime(event.target.value);
                              }}
                              style={{ width: "100%", border: "1px solid #E5E5E5", borderRadius: "10px", fontWeight: "500", fontSize: "13px", color: "#1E1E1E" }}
                              className="px-2 py-2"
                              defaultValue={new Date().toTimeString().slice(0, 5)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {selectedStatus === "Warranty" && (
                    <Row style={{ width: "100%" }}>
                      <Col sm={6} className="mt-2">
                        <div className="warrant-date-box">
                          <div className="warrant-date-box-title mb-1">Invoice date</div>
                          <div className="style-justify-start">
                            <div className="font-15-500-172B4D">{invoiceFormattedDate}</div>
                            <div className="mx-1" style={{ width: "4px", height: "4px", borderRadius: "100px", background: "#D9D9D9" }}></div>
                            <div className="ms-1 style-justify-center px-2 " style={{ background: "#DFDFDF", borderRadius: "12px", paddingTop: "4px", paddingBottom: "4px", fontSize: "12px", fontWeight: "400", color: "#172B4D" }}>
                              {warrantyPeriod} {warrantyUnit} warranty
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col sm={6} className="mt-2">
                        <div className="warrant-date-box">
                          <div className="warrant-date-box-title mb-1">Warranty end date</div>
                          <div className="style-justify-start">
                            <div className="font-15-500-172B4D">{warrantyDate !== "" ? moment(warrantyDate).format("DD MMMM YYYY") : ""}</div>
                          </div>
                        </div>
                      </Col>

                      <Col sm={6} className="mt-2">
                        <div>
                          <div className="field-title mb-1">Remind before</div>
                          <Row className="mt-1" style={{ width: "100%" }}>
                            <Col sm={7}>
                              <div>
                                <input
                                  type="text"
                                  placeholder="Enter here"
                                  className="input-field w-100"
                                  value={remindBefore}
                                  onChange={(event) => {
                                    const value = event.target.value.replace(/\D/g, "");
                                    setRemindBefore(value);
                                  }}
                                />
                              </div>
                            </Col>
                            <Col sm={5} className="px-0">
                              <div>
                                <select value={remindBeforeType} className="input-field w-100 px-2 py-2" onChange={(e) => setRemindBeforeType(e.target.value)}>
                                  <option value="Week">Week(s)</option>
                                  <option value="Month">Month(s)</option>
                                  <option value="Year">Year(s)</option>
                                </select>
                              </div>
                            </Col>

                            {/*  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.in_time}</span> */}
                          </Row>
                        </div>
                      </Col>
                      <Col sm={6} className="mt-2">
                        <div>
                          <div className="field-title mb-1">Time</div>
                          <input
                            type="time"
                            placeholder="Enter here"
                            className="input-field w-100"
                            value={remainderTime}
                            onChange={(event) => {
                              setRemainderTime(event.target.value);
                            }}
                          />
                        </div>
                      </Col>

                      {/*  <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444", }}>{validations.in_time}</span> */}
                    </Row>
                  )}
                  <div className="style-justify-between">
                    <div></div>
                    <div></div>
                  </div>
                  {errorMessage !== null && errorMessage !== "" && <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}> {errorMessage} </div>}
                </div>
              )}
              <div className="mt-2 px-3 py-3 d-flex align-items-center" style={{ borderRadius: "8px", backgroundColor: "#F0F6FF", gap: "8px" }}>
                <img src={loop} style={{ width: "16px", height: "16px" }} />
                <div className="align-items-between" style={{ flex: 1, fontWeight: "500", fontSize: "14px", color: "#3B84E6" }}>
                  {/* Repeats every 1 day */}
                  {repeatSentence()}
                </div>
                {showSender === true && (
                  <button
                    onClick={() => {
                      setShowSender(false);
                    }}
                    className="icon-btn edit-btn"
                    title="Edit"
                  >
                    <img src={edit} alt="Edit" className="icon-img" />
                  </button>
                )}
              </div>
              {showSender === true && (
                <div>
                  <Row>
                    <Col sm={12} className="mt-2">
                      <div className="field-title mb-1">
                        Template Group<span style={{ color: "#FF4444" }}>*</span>{" "}
                      </div>
                      <SearchWithAPI onDropdownChange={handleTemplateDropdownChange} apiUrl={apiUrl + "get_template_group"} params={{}} placeholder={"Select"} selectedOption={templateOption} />
                      {/* <span className="field-error">{validations.group_id}</span> */}
                    </Col>
                    <Col sm={12} className="mt-2">
                      <div className="field-title mb-1">Users</div>
                      <SearchWithAPI onDropdownChange={handleUserDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Select"} selectedOption={userOption} />
                      {/* <span className="field-error">{validations.group_id}</span> */}
                      <span
                        className="mt-1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {userErrorMsg}
                      </span>

                      <div className="mt-2" style={{ display: "flex", flexWrap: "wrap" }}>
                        {inviteUsers.map((item, userIndex) => (
                          <div
                            key={`${userIndex}-email`}
                            style={{
                              height: "36px",
                              marginLeft: "8px",
                              marginRight: "8px",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              borderRadius: "8px",
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              backgroundColor: "#F8F8F8",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <label
                              style={{
                                fontSize: "13px",
                                fontWeight: "400",
                                color: "#172B4D",
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                            >
                              {item.label}
                            </label>
                            &nbsp;
                            <img
                              src={chipClose}
                              alt="Close"
                              onClick={() => {
                                const updatedItems = [...inviteUsers];
                                updatedItems.splice(userIndex, 1);
                                setInviteUser(updatedItems);
                              }}
                              className="cursor-pointer"
                            />
                          </div>
                        ))}
                      </div>
                    </Col>
                    <Col sm={12} className="mt-2">
                      <div className="field-title mb-1">Add email</div>
                      <div className="style-justify-start w-100">
                        <div style={{ flex: 1 }}>
                          {/* <SearchWithFreeTextAPI
                        onDropdownChange={handleEmailDropdownChange}
                        onChangeSearch={handleEmailOnChange}
                        apiUrl={apiUrl + `get_booking_emails`}
                        searchLimit={0}
                        placeholder={"Type & add here..."}
                        selectedValue={emailSearch}                        
                      /> */}
                          <input type="text" placeholder="Type & add here..." className="input-field w-100" value={emailSearch} onChange={(e) => setEmailSearch(e.target.value)} />
                        </div>
                        <div
                          className="ms-1 get-tag style-justify-center cursor-pointer"
                          onClick={() => {
                            setEmailErrorMsg("");
                            if (emailSearch !== null && emailSearch !== "") {
                              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                              if (emailRegex.test(emailSearch)) {
                                const index = inviteEmails.findIndex((element) => element === emailSearch);
                                if (index === -1) {
                                  setInviteEmail([...inviteEmails, emailSearch]);
                                  setEmailSearch("");
                                  /*  setInviteEmail((prevEmails) => {
                                prevEmails.push(emailSearch);
                                setEmailSearch("");
                                return prevEmails;
                              }); */
                                } else {
                                  setEmailErrorMsg("Already exists");
                                }
                              } else {
                                setEmailErrorMsg("Please enter valid email");
                              }
                            }
                          }}
                        >
                          Add
                        </div>
                      </div>
                      <span
                        className="mt-1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {emailErrorMsg}
                      </span>

                      <div className="mt-2" style={{ display: "flex", flexWrap: "wrap" }}>
                        {inviteEmails.map((item, emailIndex) => (
                          <div
                            key={`${emailIndex}-email`}
                            style={{
                              height: "36px",
                              marginLeft: "8px",
                              marginRight: "8px",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              borderRadius: "8px",
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              backgroundColor: "#F8F8F8",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <label
                              style={{
                                fontSize: "13px",
                                fontWeight: "400",
                                color: "#172B4D",
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                            >
                              {item}
                            </label>
                            &nbsp;
                            <img
                              src={chipClose}
                              alt="Close"
                              onClick={() => {
                                const updatedItems = [...inviteEmails];
                                updatedItems.splice(emailIndex, 1);
                                setInviteEmail(updatedItems);
                              }}
                              className="cursor-pointer"
                            />
                          </div>
                        ))}
                      </div>
                    </Col>

                    <Col sm={12} className="mt-2">
                      <div className="field-title mb-1">Add mobile number</div>
                      <div className="style-justify-start w-100">
                        <div style={{ flex: 1 }}>
                          {/* <SearchWithFreeTextAPI
                        onDropdownChange={handleMobileDropdownChange}
                        onChangeSearch={handleMobileOnChange}
                        apiUrl={apiUrl + `get_booking_emails`}
                        searchLimit={0}
                        placeholder={"Type & add here..."}
                        selectedValue={mobileSearch}
                        
                      /> */}
                          <input type="text" placeholder="Type & add here..." className="input-field w-100" value={mobileSearch} onChange={(e) => setMobileSearch(e.target.value)} />
                        </div>
                        <div
                          className="ms-1 get-tag style-justify-center cursor-pointer"
                          onClick={() => {
                            setMobileErrorMsg("");
                            if (mobileSearch !== null && mobileSearch !== "") {
                              const mobileRegex = /^\d{10}$/;
                              if (mobileRegex.test(mobileSearch)) {
                                const index = inviteMobiles.findIndex((element) => element === mobileSearch);
                                if (index === -1) {
                                  setInviteMobile([...inviteMobiles, mobileSearch]);
                                  setMobileSearch("");
                                  /* setInviteMobile((prevMobiles) => {
                                prevMobiles.push(mobileSearch);
                                setMobileSearch("");
                                return prevMobiles;
                              }); */
                                } else {
                                  setMobileErrorMsg("Already exists");
                                }
                              } else {
                                setMobileErrorMsg("Please enter valid mobile");
                              }
                            }
                          }}
                        >
                          Add
                        </div>
                      </div>
                      <span
                        className="mt-1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {mobileErrorMsg}
                      </span>

                      <div className="mt-2" style={{ display: "flex", flexWrap: "wrap" }}>
                        {inviteMobiles.map((item, mobileIndex) => (
                          <div
                            key={`${mobileIndex}-mobile`}
                            style={{
                              height: "36px",
                              marginLeft: "8px",
                              marginRight: "8px",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              borderRadius: "8px",
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              backgroundColor: "#F8F8F8",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <label
                              style={{
                                fontSize: "13px",
                                fontWeight: "400",
                                color: "#172B4D",
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                            >
                              {item}
                            </label>
                            &nbsp;
                            <img
                              src={chipClose}
                              alt="Close"
                              onClick={() => {
                                const updatedItems = [...inviteMobiles];
                                updatedItems.splice(mobileIndex, 1);
                                setInviteMobile(updatedItems);
                              }}
                              className="cursor-pointer"
                            />
                          </div>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
              <div className="mt-3">
                <div className="style-justify-end">
                  <div onClick={onCancel} className="cancel-btn style-justify-center">
                    Cancel
                  </div>

                  <div
                    onClick={() => {
                      if (showSender === false) {
                        validateRemainder();
                      } else {
                        saveRemainder();
                      }
                    }}
                    className="issue-submit-btn style-justify-center px-5"
                  >
                    Next
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRemainderModal;
